import { Autocomplete, TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import { every, find, isArray } from 'lodash';

// Components
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import PaperSelect from 'src/components/common/PaperSelect';
import { getFormItemError, renderFormItemError } from 'src/utils/helpers/renderFormItemError';
import { STATUES_CONTRIBUTE } from 'src/features/Contributions/config';

const FormItemStatusContribution = () => {
  const formik = useFormikContext<ExpectedAny>();

  const getStatus = (status: string) => {
    const typeItem = find(STATUES_CONTRIBUTE, (o) => o.value === status);
    if (!typeItem) {
      return {
        value: '',
        label: '',
      };
    }
    return typeItem;
  };

  const getValue = () => {
    if (isArray(formik.values.status) && every(formik.values.status, (item) => typeof item === 'string')) {
      return formik.values.status.map((item: string) => {
        return getStatus(item);
      });
    }
    return formik.values.status;
  };

  return (
    <Autocomplete
      value={getValue()}
      multiple={true}
      size="small"
      fullWidth
      onBlur={formik.handleBlur}
      getOptionKey={(option) => option.optionLabel}
      options={getArrayDefault(STATUES_CONTRIBUTE)}
      PaperComponent={PaperSelect}
      onChange={(_, value) => {
        formik.setFieldValue(
          'status',
          value.map((status) => status.value),
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          error={Boolean(getFormItemError('status', formik))}
          helperText={renderFormItemError(getFormItemError('status', formik))}
          id="status"
          name="status"
          placeholder="Search"
          InputLabelProps={{ required: true }}
          label={<span>Filter By Status</span>}
        />
      )}
    />
  );
};

export default FormItemStatusContribution;
